<script setup lang="ts">
const { t } = useI18n({
  useScope: 'local',
});

const props = defineProps<{
  housingId: number;
}>();
</script>

<template>
  <section>
    <h1>{{ t('probably_already_swapped') }}</h1>
    <p>{{ t('no_longer_exists') }}</p>
    <div>
      <tw-housing-similar :housing-id="props.housingId" />
    </div>
  </section>
</template>

<style scoped lang="scss">
section {
  padding: 1rem;
  h1 {
    margin: 0 0 1rem;
  }
  .loading {
    text-align: center;
  }
}
</style>

<i18n lang="json">
{
  "de": {
    "probably_already_swapped": "Wahrscheinlich schon getauscht",
    "no_longer_exists": "Du willst dir eine Wohnung anschauen, die es leider nicht mehr gibt oder zur Zeit deaktiviert ist."
  },
  "en": {
    "probably_already_swapped": "Probably already swapped",
    "no_longer_exists": "You want to view a housing that no longer exists or is currently deactivated."
  }
}
</i18n>
